import { appStore } from '../../stores';
import { WithdrawalAccount } from '../../pages/Settings';
import {
	BusinessController,
	SettingsController,
	WalletController,
} from '../../controllers';
import { MimaToastUtil } from '../../components';
import { object, string } from 'yup';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const WithdrawalAccountContainer = ({ closeModal }) => {
	const [stage2, setStage2] = useState(false);
	const [loading, setLoading] = useState(false);
	const [accountName, setAccountName] = useState('');

	const onSubmit = payload => {
		if (!accountName) {
			return MimaToastUtil.error({
				message: 'Enter a valid bank and account number combination',
			});
		}
		payload.accountName = accountName;
		localStorage.setItem(constant.RouteParams, JSON.stringify(payload));
		setStage2(true);
	};

	const onSubmitPIN = async token => {
		setLoading(true);
		const payload = JSON.parse(localStorage.getItem(constant.RouteParams));
		payload.pin = token;
		const { status, errorMessage } =
			await SettingsController.setWithdrawalAccount(payload);
		if (status === constant.Success) {
			await BusinessController.businessDetails();
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const validationSchema = () =>
		object({
			bankCode: string().required('Select a bank'),
			accountNumber: string().required('Account Number is required'),
		});

	const verifyAccountNumber = async payload => {
		if (
			payload.beneficiaryBank &&
			payload.accountNumber &&
			payload.accountNumber.length === 10
		) {
			const { status, data, errorMessage } =
				await WalletController.verifyAccountNumber(payload);
			if (status === constant.Success) {
				return data.accountName;
			} else {
				MimaToastUtil.error({
					message: errorMessage,
				});
			}
		}
		return '';
	};

	return (
		<WithdrawalAccount
			stage2={stage2}
			onSubmit={onSubmit}
			onSubmitPIN={onSubmitPIN}
			accountName={accountName}
			setAccountName={setAccountName}
			setLoading={setLoading}
			verifyAccountNumber={verifyAccountNumber}
			validationSchema={validationSchema}
			loading={loading}
			banks={appStore.banks.map(bank => {
				return { id: bank.key, value: bank.value };
			})}
			closeModal={closeModal}
		/>
	);
};

export default observer(WithdrawalAccountContainer);
